import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "../api";
import { Container, Spinner, Button, Alert } from "react-bootstrap";

export default function NewsDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [news, setNews] = useState(null);
  const [allNews, setAllNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const touchStartX = useRef(null);

  const IMAGE_URL = process.env.REACT_APP_UPLOAD_URL;

  const getImageUrl = (file) => {
    if (!file) return "/default-news.jpg";

    return `${IMAGE_URL}/uploads/${file}`;
  };

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        setError("");

        const [resDetail, resAll] = await Promise.all([
          API.get(`/news/${id}`),
          API.get("/news"),
        ]);

        setNews(resDetail.data);
        setAllNews(resAll.data || []);

        console.log("News Detail:", resDetail.data);
        console.log("All News:", resAll.data);
        console.log("IMAGE_URL:", IMAGE_URL);
      } catch (err) {
        console.error("Load news error:", err);
        setError("Gagal memuat berita");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [id, IMAGE_URL]);

  const currentIndex = allNews.findIndex(
    (item) => item.id === news?.id
  );

  const prevNews =
    currentIndex > 0
      ? allNews[currentIndex - 1]
      : null;

  const nextNews =
    currentIndex >= 0 &&
    currentIndex < allNews.length - 1
      ? allNews[currentIndex + 1]
      : null;

  const goPrev = () => {
    if (prevNews) {
      navigate(`/news/${prevNews.id}`);
    } else {
      navigate("/");
    }
  };

  const goNext = () => {
    if (nextNews) {
      navigate(`/news/${nextNews.id}`);
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowLeft") goPrev();
      if (e.key === "ArrowRight") goNext();
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener(
        "keydown",
        handleKeyDown
      );
    };
  }, [prevNews, nextNews]);

  const handleTouchStart = (e) => {
    touchStartX.current =
      e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    if (!touchStartX.current) return;

    const endX =
      e.changedTouches[0].clientX;

    const diff =
      touchStartX.current - endX;

    const threshold = 50;

    if (diff > threshold) {
      goNext();
    } else if (diff < -threshold) {
      goPrev();
    }

    touchStartX.current = null;
  };

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" />
        <p className="mt-2">
          Memuat berita...
        </p>
      </div>
    );
  }

  if (error) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">
          {error}
        </Alert>

        <Button
          variant="secondary"
          onClick={() => navigate("/")}
        >
          Kembali ke Beranda
        </Button>
      </Container>
    );
  }

  if (!news) {
    return (
      <Container className="mt-5 text-center">
        <h4>Berita tidak ditemukan</h4>

        <Button
          className="mt-3"
          onClick={() => navigate("/")}
        >
          Kembali ke Beranda
        </Button>
      </Container>
    );
  }

  return (
    <Container
      className="mt-4"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      style={{ userSelect: "none" }}
    >
      {/* Navigation Top */}
      <div className="d-flex justify-content-between mb-3">
        <Button
          variant="outline-secondary"
          onClick={goPrev}
        >
          ← Sebelumnya
        </Button>

        <Button
          variant="outline-secondary"
          onClick={goNext}
          disabled={!nextNews}
        >
          Berikutnya →
        </Button>
      </div>

      {/* Title */}
      <h2 className="mb-3">
        {news.title}
      </h2>

      {/* Image */}
      {news.image && (
        <img
          src={getImageUrl(news.image)}
          alt={news.title}
          onError={(e) => {
            e.target.src =
              "/default-news.jpg";
          }}
          style={{
            width: "100%",
            borderRadius: "10px",
            marginBottom: "20px",
            maxHeight: "500px",
            objectFit: "cover",
          }}
        />
      )}

      {/* Content */}
      <div
        style={{
          textAlign: "justify",
          lineHeight: "1.8",
          whiteSpace: "pre-line",
        }}
      >
        {news.content}
      </div>

      {/* Buttons */}
      <div className="d-flex gap-2 mt-4">
        <Button
          variant="primary"
          onClick={() => navigate(-1)}
        >
          ← Kembali
        </Button>

        <Button
          variant="secondary"
          onClick={() => navigate("/")}
        >
          🏠 Beranda
        </Button>
      </div>

      {/* Hint */}
      <p
        className="text-center text-muted mt-4"
        style={{ fontSize: "12px" }}
      >
        Gunakan tombol ⬅️ ➡️ keyboard
        atau swipe untuk navigasi berita
      </p>
    </Container>
  );
}